// removed by extract-text-webpack-plugin
module.exports = {"switchContainer":"_2l19p7_dmjyq-nTrmVZhY-","switchLabel":"_2kNSYcn2Fdfa-EVXWPW9D9","switchText":"_3DEbK8u-ndWa-uUuqQmD1o","column":"_2zH2ErR6ncx_kkQ2tkCGhf","switchButton":"_36dRjDmJzrOX1aSXQZ5kt0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMSwitch/OMSwitch.scss
// module id = 1675
// module chunks = 0